import { useState, useEffect } from 'react';
import { getUserSettingsSelectorCurrenciesListAsync } from '@Components/Utilities/SandhillsUtility';
import { saveUserSettingsCookie } from '@Components/Utilities/CookieHelper';
import TranslationText from '@Components/Utilities/TranslationText';
import ready from 'document-ready';
import Box from '@mui/material/Box';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';

import Combobox from '@Components/MuiWrappers/Combobox';

const CurrencySelector = (props) => {

    // Old Version
    const styles = {
        id: props.id || 'currency-dropdown',
        className: props.className || 'currency-select',
        containerClassName: props.containerClassName || 'currency-select-container',
        labelClassName: (props.hideLabel ? 'visually-hidden ' : '') + (props.boldLabel ? 'bold ' : '') + 'select-your-currency',
        optionClassName: props.optionClassName || 'currency-selector-option'
    };
    const [currencies, setCurrencies] = useState(props.Currencies);
    const routes = useRecoilValue(atoms.routes);
    useEffect(() => {
        ready(() => {
            getUserSettingsSelectorCurrenciesListAsync(props.CurrenciesSessionStorageKey, currencies, routes.GetCurrenciesAndCultures)
                .then(data => {
                    setCurrencies(data);
                })
                .catch(error => alert('An error occurred while attempting to retrieve currencies.'));
        });
    }, []);
    const currencyChange = (e) => {
        if (props.onChange) {
            props.onChange(e.target.value);
        } else {
            saveUserSettingsCookie({ currency: e.target.value, url: routes.SaveUserSettings })
                .then(data => {
                    window.location.href = data.url;
                })
                .catch(error => {
                    console.log('Error saving UserSettings cookie: ', error);
                    window.location.reload(true);
                });
        }
    };

    const getOptionLabel = (option) => {
        return option.Value ? option.Value : option.DisplayText;
    };

    const renderOption = (optionsProps, option) => {
        var dropdownOption = {
            Key: option.CurrencyCode,
            Value: option.DisplayText
        };

        return (
            <Box component="li" {...optionsProps}>
                <div><span>{getOptionLabel(dropdownOption)}</span></div>
            </Box>
        );
    };

    // MUI
    const onChange = (event, option, reason, details) => {
        if (reason == 'selectOption') {
            const currencyCode = option.CurrencyCode;
            if (props.onChange) {
                props.onChange(currencyCode);
            } else {
                saveUserSettingsCookie({ currency: currencyCode, url: routes.SaveUserSettings })
                    .then(data => {
                        window.location.href = data.url;
                    })
                    .catch(error => {
                        console.log('Error saving UserSettings cookie: ', error);
                        window.location.reload(true);
                    });
            }
        }
    };

    return (
        <div className={styles.containerClassName}>
            {props.useMUI ?
                <Combobox
                    label={translator.translate('sandhills.tradesites.mvc.selectyourcurrency')}
                    value={currencies.filter(l => l.CurrencyCode == props.value)[0]}
                    options={currencies}
                    renderOption={renderOption}
                    getOptionLabel={getOptionLabel}
                    onChange={onChange}
                />
                :
                <>
                    <div className={props.labelClassName}>
                        <label htmlFor={styles.id} className={styles.labelClassName}>
                            {props.label ? props.label : <TranslationText tKey='sandhills.tradesites.mvc.selectyourcurrency' />}{props.required && <span className='required' />}
                        </label>
                    </div>
                    <select
                        id={styles.id}
                        name={props.name}
                        required={props.required}
                        className={styles.className}
                        onChange={currencyChange}
                        value={props.value != currencies[0].CurrencyCode ? props.value : ''}
                    >
                        {currencies.map(c =>
                            <option key={c.CurrencyCode} value={c.CurrencyCode} className={styles.optionClassName}>{c.CurrencyCode}</option>)}
                    </select>
                </>
            }

        </div>
    );
};

export default CurrencySelector;